<template>
<!--=== Content Part ===-->
    <div > 
        <!--Banner Start Here -->
        <section class="banner2">
            <div class="container clearfix">
                <div class="banner__caption2">
                    <h1 nowrap>FAQ</h1><br>
                </div>
            </div>
        </section>
        <!--Banner End Here -->  
        <div class="row-fluid privacy container" >
        <!-- BEGIN -->
            <div class="row">            
                    <div class="col-md-12">
                        <!-- General Questions -->
                        <div class="headline"><h2>{{$t('FAQ.bloc1.title')}}</h2></div>
                        <div class="panel-group acc-v1 margin-bottom-40" id="accordion">
                            
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse1" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q1')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse1" class="panel-collapse collapse in">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a1')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse2" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q2')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse2" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a2')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse3" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q3')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse3" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a3')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse4" ng-click="tabClick($event)">
                                        {{$t('FAQ.bloc1.q4')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse4" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a4')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse5" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q5')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse5" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a5')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse6" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q6')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse6" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a6')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse7" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q7')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse7" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a7')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse8" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q8')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse8" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a8')}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapse9" ng-click="tabClick($event)">
                                            {{$t('FAQ.bloc1.q9')}}
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse9" class="panel-collapse collapse ">
                                    <div class="panel-body">
                                        <h5>{{$t('FAQ.bloc1.a9')}}<br><br>
                                            <ul>
                                                <li>{{$t('FAQ.bloc1.mood-blue')}}</li>
                                                <li>{{$t('FAQ.bloc1.mood-green')}}</li>
                                                <li>{{$t('FAQ.bloc1.mood-red')}}</li>
                                            </ul> 
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End General Questions -->
                        <!--<%= ad_unit(:vertical_banner, "ca-pub-3339929736614212", {:slot => "2060146281",:format => "rectangle,horizontal"}) %>-->

                    </div>
            </div>
            <div class="row centered">
                <div class="col-md-12 "
                        <h6><i>{{$t('FAQ.bloc1.help')}}</i></h6>
                </div>
            </div>
        <!-- END -->
               <p>&nbsp;</p><br><br><br>
        </div>
        
    </div>
</template>

<script>
export default {
  name: 'FAQ'
}
</script>
<style>
.legal p {
    font-size: 1.4em;
    line-height: 1.4;
}
</style>



// WEBPACK FOOTER //
// FAQ.vue?6c3118e3